import 'whatwg-fetch';

import { AccessTokenManager } from '@spotify-internal/access-token';
import { getImplicitGrantFlowToken } from '@spotify-internal/web-auth';
import {
  configure,
  webgateFetch as sharedWebgateFetch,
  webgateFetchJson as sharedWebgateFetchJson,
} from '@mrkt/features/webgate-fetch';
import { CLIENT_ID_S4A_ONBOARDING, CLIENT_ID_S4A_WEB } from './constants';
import { toJSON, verifyResponse, API } from './helpers';

export * from './constants';

// access token managers
export const accessTokenManager = AccessTokenManager.createUser(
  CLIENT_ID_S4A_WEB,
);

if (process.env.REACT_APP_SLINGSHOT) {
  accessTokenManager.get = () =>
    getImplicitGrantFlowToken({
      client_id: CLIENT_ID_S4A_WEB,
      redirect_uri: `${window.location.origin}/`,
    });
}

export const anonymousAccessTokenManager = AccessTokenManager.createAnonymous(
  CLIENT_ID_S4A_ONBOARDING,
);

// APIs
const { version, pkgVersion } = document.body.dataset;
const defaultWebgateHeaders = {
  accept: 'application/json',
  'content-type': 'application/json',
  'spotify-app-version': `${pkgVersion}.${version}`,
  'app-platform': 'Browser',
};
const mapResponse = response => toJSON(verifyResponse(response));

// DO NOT USE THIS! USE webgateFetch instead!
export const webgate = new API({
  defaultHeaders: defaultWebgateHeaders,
  getAccessToken: accessTokenManager.get.bind(accessTokenManager),
  mapResponse,
});

export const webgateAnonymous = new API({
  defaultHeaders: defaultWebgateHeaders,
  getAccessToken: anonymousAccessTokenManager.get.bind(
    anonymousAccessTokenManager,
  ),
  mapResponse,
});

// DO NOT USE THIS! USE webgateFetch instead!
export const webapi = new API({
  baseUrl: 'https://api.spotify.com',
  getAccessToken: accessTokenManager.get.bind(accessTokenManager),
  mapResponse,
});

export const webapiAnonymous = new API({
  baseUrl: 'https://api.spotify.com',
  getAccessToken: anonymousAccessTokenManager.get.bind(
    anonymousAccessTokenManager,
  ),
  mapResponse,
});

// export legacy helpers
const { request, get, post, put, patch, delete: del } = webgate;
export { request, get, post, put, patch, del };

export async function webapiFetch(url, options = {}) {
  const token = await accessTokenManager.get();

  return fetch(url, {
    ...options,
    credentials: 'same-origin',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      ...options.headers,
      authorization: `Bearer ${token}`,
    },
  });
}

configure({ getToken: accessTokenManager.get, version, pkgVersion });
// DEPRECATED! Just use webgateFetch from
// @mrkt/features/webgate-fetch
export async function webgateFetch(...args) {
  return sharedWebgateFetch(...args);
}

// DEPRECATED! Just use webgateFetch from
// @mrkt/features/webgate-fetch
export async function webgateFetchJson(...args) {
  return sharedWebgateFetchJson(...args);
}
